import { FC } from 'react';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { Box, Text, TextProps } from '@chakra-ui/react';

interface ChakraHighlightSelectionProps extends TextProps {
  highlight: string;
  inputValue: string;
}
// TODO: After Chakra-UI upgrade refactor using https://chakra-ui.com/docs/components/highlight component
export const ChakraHighlightSelection: FC<ChakraHighlightSelectionProps> = ({
  highlight,
  inputValue,
  ...rest
}) => {
  const matches = match(highlight, inputValue);
  const parts = parse(highlight, matches);
  return (
    <Box data-testid={highlight} overflow="hidden" textOverflow="ellipsis">
      {parts.map(
        (part: { highlight: boolean; text: string }, index: number) => (
          <Text
            as="span"
            // eslint-disable-next-line react/no-array-index-key
            key={`item-${index}`}
            fontWeight={part.highlight ? 700 : 400}
            whiteSpace="nowrap"
            {...rest}
          >
            {part.text}
          </Text>
        )
      )}
    </Box>
  );
};
